module.exports = __webpack_public_path__ + "static/media/help.f9a69ba1.png";